module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/MomentsOfPleasure_Wine_bg.5235698e.jpg";